/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolcardrejectedfallback3Inputs */

const en_toolcardrejectedfallback3 = /** @type {(inputs: Toolcardrejectedfallback3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rejected`)
};

const pt_toolcardrejectedfallback3 = /** @type {(inputs: Toolcardrejectedfallback3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rejeitado`)
};

/**
* | output |
* | --- |
* | "rejected" |
*
* @param {Toolcardrejectedfallback3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const toolcardrejectedfallback3 = /** @type {((inputs?: Toolcardrejectedfallback3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolcardrejectedfallback3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toolcardrejectedfallback3(inputs)
	return pt_toolcardrejectedfallback3(inputs)
});
export { toolcardrejectedfallback3 as "toolCardRejectedFallback" }